import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { AppLoaderService } from '../../@theme/shared/services/app-loader/app-loader.service';
import { NavigationService } from '../../@theme/shared/services/navigation.service';
import { ActionPermission } from './actions';
import { SecureMenuItem } from './secure-menu';

@Injectable({
  providedIn: 'root'
})
/**Retreive access rights related to logged in user */
export class AccessRightsService {
  public _accessRightActions: ActionPermission[] | undefined = undefined;

  // private _menu: SecureMenuItem[] = [
  //   {
  //     name: 'Dashboard',
  //     tooltip: 'Dashboard',
  //     state: 'home',
  //     type: 'link',
  //     icon: 'dashboard',
  //   },
  //   {
  //     name: 'Job Requisitions',
  //     type: 'dropDown',
  //     tooltip: 'Requisitions',
  //     icon: 'work',
  //     /* hide Job Requisitions Header tag if user has restricted access for viewing Job Requisitions screen */
  //     accessRightActionId: ActionPermission.viewRequisitions,
  //     sub: [
  //       {
  //         name: 'New Requisition',
  //         state: 'job-requisitions/new',
  //         type: 'link',
  //         icon: 'add',
  //         accessRightActionId: ActionPermission.createRequisition,
  //       },
  //       /* new screen "Draft Requisitions" under Job Requisitions menu using same backend's GetRequisitionsList with filtered param */
  //       { name: 'Drafts', state: 'job-requisitions/draft/list', icon: 'list', accessRightActionId: ActionPermission.viewRequisitions },
  //       /* new screen "My Requisitions" under Job Requisitions menu using same backend's GetRequisitionsList with filtered param */
  //       { name: 'My Requisitions', state: 'job-requisitions/my-list', icon: 'list', accessRightActionId: ActionPermission.viewRequisitions },
  //       /* only admin can unarchive a job requisition */
  //       { name: 'Archived List', state: 'job-requisitions/archived/list', icon: 'list', accessRightActionId: ActionPermission.manageSettings }
  //     ]
  //   },

  //   {
  //     name: 'Hiring Requests',
  //     type: 'dropDown',
  //     tooltip: 'Hiring Requests',
  //     icon: 'back_hand',
  //     /* hide Hiring Request Header tag if user has restricted access for viewing Hiring Request screen */
  //     accessRightActionId: ActionPermission.viewHiringRequests,
  //     sub: [
  //       {
  //         name: 'New Hiring Request',
  //         state: 'hiring-requests/new',
  //         type: 'link',
  //         icon: 'add',
  //         accessRightActionId: ActionPermission.createHiringRequest,
  //       },
  //       { name: 'List', state: 'hiring-requests/list', icon: 'list', accessRightActionId: ActionPermission.viewHiringRequests },
  //     ]
  //   },
  //   {
  //     name: 'Candidates',
  //     tooltip: 'Candidates',
  //     type: 'dropDown',
  //     icon: 'groups',
  //     accessRightActionId: ActionPermission.viewCandidates,
  //     sub: [
  //       { name: 'All Candidates', state: 'candidates/list', icon: 'list', accessRightActionId: ActionPermission.viewCandidates },
  //       { name: 'Possible Future Candidates', state: 'candidates/potential/list', icon: 'list', accessRightActionId: ActionPermission.viewCandidates },
  //       { name: 'Blocklisted Candidates', state: 'candidates/blocklisted', icon: 'list', accessRightActionId: ActionPermission.manageSettings },
  //       { name: 'Last Visited Candidates', state: 'candidates/last-visited/list', icon: 'list', accessRightActionId: ActionPermission.viewCandidates },
  //       { name: 'Favorite Candidates', state: 'candidates/favorite/list', icon: 'list', accessRightActionId: ActionPermission.viewCandidates }
  //     ]
  //   },
  //   {
  //     name: 'Reports',
  //     type: 'dropDown',
  //     tooltip: 'Reports',
  //     accessRightActionId: ActionPermission.generateReports,
  //     icon: 'report',
  //     sub: [
  //       { name: 'New', state: 'reports/new', icon: 'add' },
  //       { name: 'List', state: 'reports/list', icon: 'list' }
  //     ]
  //   },
  //   {
  //     name: 'Settings',
  //     type: 'dropDown',
  //     tooltip: 'Settings',
  //     icon: 'settings',
  //     accessRightActionId: ActionPermission.manageSettings,
  //     sub: [
  //       { name: 'Continents', state: 'settings/continents', icon: 'public' },
  //       { name: 'Countries', state: 'settings/countries', icon: 'flag' },
  //       { name: 'Locations', state: 'settings/locations', icon: 'map' },
  //       { name: 'Entities', state: 'settings/entities', icon: 'business' },
  //       { name: 'Departments', state: 'settings/job-departments', icon: 'work' },
  //       { name: 'Divisions', state: 'settings/divisions', icon: 'menu' },
  //       { name: 'About SABIS®', state: 'settings/about-sabis', icon: 'info' },
  //       { name: 'Admin Data Privacy', state: 'settings/admin-data-privacy', icon: 'privacy_tip' },
  //       { name: 'Data Privacy', state: 'settings/data-privacy', icon: 'privacy_tip' },
  //       { name: 'Job Descriptions', state: 'settings/job-descriptions/list', icon: 'work' },
  //       { name: 'Job Types', state: 'settings/job-types', icon: 'pentagon' },
  //       { name: 'Contract Types', state: 'settings/contract-types/list', icon: 'description' },
  //       { name: 'Requisition Types', state: 'settings/requisition-types', icon: 'border_all' },
  //       { name: 'Document Types', state: 'settings/document-types', icon: 'tab' },
  //       { name: 'Email Logs', state: 'emails/list', icon: 'mail' },
  //       { name: 'Email Templates', state: 'settings/email-templates/list', icon: 'tune' },
  //       { name: 'Feedback Form Templates', state: 'settings/feedback-forms/templates', icon: 'feedback' },
  //       { name: 'Selection Steps', state: 'settings/recruitment-steps/list', icon: 'tune' },
  //       { name: 'Users', state: 'settings/users/list', icon: 'people' },
  //       { name: 'List of Values', state: 'settings/list-of-values', icon: 'menu' },
  //       { name: 'Hear About SABIS®', state: 'settings/hear-about-sabis/categories', icon: 'list' },
  //       { name: 'Blocklisted Reasons', state: 'settings/blocklisted-reasons', icon: 'person_off' },
  //       // { name: 'Application Forms Templates', state: 'settings/application-forms/templates', icon: 'tune' },
  //       // { name: 'Feedback Forms', state: 'settings/feedback-forms/1/editor', icon: 'tune' },
  //     ]
  //   },
  //   {
  //     name: 'Additional Fields',
  //     type: 'dropDown',
  //     tooltip: 'Additional Fields',
  //     icon: 'settings',
  //     accessRightActionId: ActionPermission.manageSettings,
  //     sub: [
  //       { name: 'Preferable Age Ranges', state: 'settings/preferable-age-ranges', icon: '< >' },
  //       { name: 'Preferable Employment Statuses', state: 'settings/preferable-employment-statuses', icon: 'person' },
  //       { name: 'Preferable Genders', state: 'settings/preferable-genders', icon: 'male female' },
  //       { name: 'Priority Levels', state: 'settings/priority-levels', icon: 'priority_high' },
  //       { name: 'Years of Experience', state: 'settings/years-of-experience', icon: 'work' },
  //     ]
  //   },
  //   {
  //     name: 'Hiring Request Settings',
  //     type: 'dropDown',
  //     tooltip: 'Hiring Request Settings',
  //     icon: 'settings',
  //     accessRightActionId: ActionPermission.manageSettings,
  //     sub: [
  //       { name: 'Currencies', state: 'settings/currencies', icon: 'money' },
  //       { name: 'Employment Types', state: 'settings/employment-types', icon: 'assignment' },
  //       { name: 'HQ Legal Entities', state: 'settings/legal-entities', icon: 'house' },
  //       { name: 'Job Positions', state: 'settings/job-positions', icon: 'wallet' },
  //       { name: 'Included In Budget', state: 'settings/included-in-budget-options', icon: 'account_balance_wallet' },
  //       { name: 'Additional Headcount', state: 'settings/additional-headcount-options', icon: 'groups' },
  //       { name: 'Workflows', state: 'settings/workflows/list', icon: 'tune' },
  //     ]
  //   },
  //   {
  //     name: 'Test - Apply',
  //     type: 'link',
  //     state: 'settings/application-forms/1/editor',
  //     icon: 'tune'
  //   }
  // ];


  private _menu: SecureMenuItem[] = [
    {
      name: 'Pages',
      type: 'dropDown',
      tooltip: 'Pages',
      icon: 'back_hand',
      sub: [
        { name: 'Guide', state: 'pages/guide/list', icon: 'list' },
        { name: 'Info', state: 'pages/info/list', icon: 'list' },
      ]
    }
  ];


  constructor(private _http: HttpClient, @Inject('API_URL') private _apiUrl: string,
    private _navigationService: NavigationService,
    private _loader: AppLoaderService) { }

  /** get all allowed Access Rights actions for logged in user */
  // public getAccessRights(): Observable<number[]> {

  //   // return cached access rights
  //   if (this._accessRightActions) {
  //     return of(this._accessRightActions);
  //   }

  //   this._loader.showLoader('Authenticating...Please wait');

  //   let url: string = `${this._apiUrl}/access-rights`;

  //   return this._http.get<any[]>(url).pipe(map((actions: number[]) => {
  //     this._accessRightActions = actions
  //     this.loadMenu();
  //     this._loader.hideLoader();
  //     return this._accessRightActions;
  //   }));
  // }

  /** check if logged-in user has access rights (boolean response from server) */
  public getAccessRights(): Observable<boolean> {
    let url: string = `${this._apiUrl}/users/can-login-cms`;

    this._loader.showLoader('Authenticating...Please wait');

    return this._http.get<boolean>(url).pipe(
      tap(() => {
        this.loadMenu();
        this._loader.hideLoader();
      }),
      catchError(err => {
        this._loader.hideLoader();
        console.error('Access rights check failed', err);
        return of(false); // fallback in case of error
      })
    );
  }

  private loadMenu(): void {
    // keep only items with access rights
    // var allowedMenuitems = this._menu.filter(m => !m.accessRightActionId || this._accessRightActions!.includes(m.accessRightActionId));
    // allowedMenuitems.filter(mi => mi.sub)
    //   .forEach(mi => {
    //     mi.sub = mi.sub!.filter(s => !s.accessRightActionId || this._accessRightActions!.includes(s.accessRightActionId));
    //   });

    // // keep "Test - Apply" if testing env [dev, staging, po]
    // allowedMenuitems = allowedMenuitems.filter(i =>
    //   (i.name !== 'Test - Apply' && i.name !== 'Application Forms Templates')
    //   ||
    //   window.location.hostname.indexOf('localhost') > -1);
    var allowedMenuitems = this._menu;
    this._navigationService.setMenu(allowedMenuitems);
  }

  /** ensure current user is allowed to access this app */
  // public ensureHasAccessRights(): Observable<boolean> {
  //   return this.getAccessRights().pipe(
  //     map(r => {
  //       return r.length > 0;
  //     })
  //   );
  // }

  /** ensure current user is allowed to access this app */
  public ensureHasAccessRights(): Observable<boolean> {
    return this.getAccessRights();
  }

  /** Check if user has access to specific action */
  public hasAccessTo(action: ActionPermission): boolean {
    if (this._accessRightActions!.includes(action)) {
      return true
    }

    return false;
  }
}
